import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const getDriversList = ({
  page,
  pageSize,
  search = '',
  orderBy,
  orderDirection,
}) =>
  privateAxios({
    method: 'post',
    baseURL: adminAPI,
    url: '/driver/list',
    data: {
      page,
      pageSize,
      search,
      orderBy,
      orderDirection,
    },
  });
